import { ORG_CONFIG } from 'src/api/routes';
import { GET } from 'src/network/apiHandler';
import config from 'src/globals';

const { WB_BASE_URL } = config;

export const getOrgConfig = async (param) => {
  return GET(`${WB_BASE_URL}${ORG_CONFIG}?${param}`);
};
